export default __webpack_public_path__ + "static/media/games.0d06fb9f.png";